import { Component, OnInit } from '@angular/core';
import {LocationStrategy} from '@angular/common';
import {OtherTemplatesService} from '../../../../services/other-templates.service';
import {ToastService} from 'angular-toastify';
import {ActivatedRoute, Router} from '@angular/router';

@Component({
  selector: 'app-other-templates-add',
  templateUrl: './other-templates-add.component.html',
  styleUrls: ['./other-templates-add.component.css']
})
export class OtherTemplatesAddComponent implements OnInit {
  externalUrlPreview: string;
  templateName = '';
  canAdd = false;


  constructor(
    private locationStrategy: LocationStrategy,
    private templateService: OtherTemplatesService,
    private toastService: ToastService,
    private router: Router,
    private route: ActivatedRoute,
  ) { }

  ngOnInit(): void {
    this.changeTemplateName();
  }

  getExternalUrl(templateName: string) {
    // TODO dont hardcode
    return 'https://cardbro.cardcompact.com' + this.locationStrategy.prepareExternalUrl('/documents/' + templateName);
  }

  checkExistsTimeout: ReturnType<typeof setTimeout>|null;

  changeTemplateName() {

    this.templateName = this.templateName.replace(/[^0-9a-z_]/gi, '');
    this.externalUrlPreview = this.getExternalUrl(this.templateName);

    this.canAdd = false;

    if ( !this.templateName ) {
return;
}

    if ( !this.checkExistsTimeout ) {
      this.checkExistsTimeout = setTimeout(() => {

        this.templateService.checkExists(this.templateName).subscribe(e => {
            this.canAdd = !e;
            this.checkExistsTimeout = null;
          }, error => {
            this.canAdd = true;
            this.checkExistsTimeout = null;
          }
        );
      }, 2000);
    }



  }

  addTemmplate() {
    this.templateService.createTemplate(this.templateName).subscribe(t => {
      this.router.navigate(['..', t.name],{relativeTo: this.route});
    }, err => {

    });
  }
}
